import { GetStockItem4TransferFGResult, TransferFGSearch } from './../model/stock-transfer-serial.model';
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { catchError, map, tap } from 'rxjs/operators';
import { environment } from "../../environments/environment";
import { User } from '../model/user.model';
import { LotAcceptanceSearch, LotAcceptanceTest, LotAcceptanceTestDetail } from '../model/lat-acceptance.model';


const API_URL = environment.apiUrl;
const httpOptions = {
    headers: new HttpHeaders(
        {
            'Content-Type': 'application/json',
        }
    )
};

@Injectable()
export class LotAcceptanceService {
    private Url = '';  // URL to web api
    currentUser: User;

    constructor(
        private http: HttpClient) {
        this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
        this.Url = API_URL + '/' + (this.currentUser.CompanyID ? this.currentUser.CompanyID.toString() : "1") + '/lotacceptance';

    }

    GetLotAcceptanceTestList(search: LotAcceptanceSearch): Observable<LotAcceptanceTest[]> {
        return this.http.post<LotAcceptanceTest[]>(this.Url + "/GetLotAcceptanceTestList", search, httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }

    GetLotAcceptanceTestData(search: LotAcceptanceSearch): Observable<any> {
        return this.http.post<any>(this.Url + "/GetLotAcceptanceTestData", search, httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }

    AddLotAcceptance(data: LotAcceptanceTest): Observable<any> {
        return this.http.post<any>(this.Url + "", data, httpOptions)
            .pipe(
                tap(response => { })
            );
    }

    GetLotAcceptanceTestListForExport(search: LotAcceptanceSearch, type: number): Observable<any> {

        return this.http.post(this.Url + '/GetLotAcceptanceTestListForExport/' + type, search, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',

            }),
            responseType: 'arraybuffer'
        }).pipe(tap((x) => {
        }),
            //catchError(this.handleError<StockTransferOrderSearch>('SearchWorkPermit'))
        );
    }

}


// WEBPACK FOOTER //
// ./src/app/services/lot-acceptance.service.ts